import { useTranslation } from 'react-i18next'
import { AlertCircle } from 'lucide-react'
import { useScenarios } from '@/hooks/useScenarios'
import LoadingSpinner from '@/components/common/LoadingSpinner'
import ScenarioWorkspace from './ScenarioWorkspace'

interface ScenarioPanelProps {
  siteId: string
  machineId: string
}

export default function ScenarioPanel({
  siteId,
  machineId,
}: ScenarioPanelProps) {
  const { t } = useTranslation()
  const s = useScenarios(siteId, machineId)

  const isConnecting = s.connectState === 'connecting' || s.isLoading

  return (
    <div className="flex-1 flex flex-col min-h-0 relative">
      {s.error ? (
        <div className="p-4">
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700 flex items-center gap-2">
            <AlertCircle className="w-4 h-4 flex-shrink-0" />
            {s.error === 'connect'
              ? t('scenarios.connectError')
              : t('scenarios.loadError')}
          </div>
        </div>
      ) : isConnecting && s.viewMode === 'list' ? (
        <div className="flex-1 flex flex-col items-center justify-center py-16 text-gray-500 gap-3">
          <LoadingSpinner size="lg" />
          <p className="text-sm">{t('scenarios.connecting')}</p>
        </div>
      ) : (
        <ScenarioWorkspace s={s} />
      )}

      {/* 通知バナー */}
      {s.notice && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-sm px-4 py-2 rounded-lg shadow-lg z-50">
          {s.notice}
        </div>
      )}
    </div>
  )
}
